import axios from "axios";

const validateClient = async ({
  clientId,
  accessToken,
  environment,
}: {
  clientId: string;
  accessToken: string;
  environment: string;
}): Promise<{ clientName: string }> => {
  let clientName = "";
  try {
    const clientDetailsRes = await axios({
      baseURL:
        environment === "production" ? process.env.REACT_APP_EXT_API_URL_PROD : process.env.REACT_APP_EXT_API_URL_DEV,
      url: `/ClientInfo/${clientId}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    clientName = clientDetailsRes?.data?.clientInfo?.companyName || "";
  } catch (e) {
    // do something
  }
  return {
    clientName,
  };
};

export default validateClient;
